<div class="authorization-page">
  <mat-card class="authorization-card">
    <h2>Authorization Request</h2>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <div *ngIf="!errorMessage">
      <div class="meta">
        <div><span class="label">Portal ID:</span> {{ portalId }}</div>
        <div><span class="label">Request ID:</span> {{ requestId }}</div>
      </div>
      <div class="loading" *ngIf="isLoading">
        <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
      </div>
      <div *ngIf="authorizationRequest">
        <div class="field">
          <span class="label">Valid:</span> {{ authorizationRequest.is_valid }}
        </div>
        <div class="field">
          <span class="label">Conditions:</span>
          <pre>{{ authorizationRequest.conditions | json }}</pre>
        </div>
      </div>
      <div class="field">
        <span class="label">Update Payload (JSON):</span>
        <textarea
          rows="6"
          [value]="payloadText"
          (input)="updatePayloadText($any($event.target).value)"
          [disabled]="isLoading"
        ></textarea>
        <p class="error" *ngIf="payloadError">{{ payloadError }}</p>
      </div>
      <div class="actions">
        <button mat-stroked-button (click)="refresh()" [disabled]="isLoading">
          Refresh
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="submitUpdate()"
          [disabled]="isLoading || !!payloadError"
        >
          Submit/Update
        </button>
      </div>
    </div>
  </mat-card>
</div>
